<template>
  <div>
    <span
      v-if="params.value === '#NA#'"
      class="na-grid-cell"
    >
      N/A
    </span>

    <span
      v-else-if="params.value === '#NREF#' || ((this.params.data && this.params.column ? this.params.data[this.params.column.colId] === undefined : false) && this.params.nref)"
      class="nref-grid-cell"
    >⠀</span>
    <div v-else-if="params.value && JSON.parse(params.value.toString().toLowerCase())" class="d-flex"><i class="fas fa-check-square"></i></div>
    <div v-else class="d-flex"><i class="far fa-square"></i></div>
  </div>
</template>

<script>
export default {
  name: 'CheckboxRenderer'
}
</script>

<style scoped>
i.fas {
  color: #007bff;
}
div {
  height: 100%;
  width: 100%;
}
div.d-flex {
  justify-content: center;
  align-items: center;
}
span.na-grid-cell,
span.nref-grid-cell {
  display: block;
  text-align: center;
  position: relative;
  z-index: 6;
  margin: 0 auto;
  height: 100%;
  font-weight: 700;
  overflow: hidden;
}

span.nref-grid-cell {
  background: #2a2a2acb;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/CheckboxRenderer.vue